"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewValueAtRiskTable = exports.OverviewValueAtRiskContainer = void 0;
var React = require("react");
var container_1 = require("./container");
var charts_1 = require("./charts");
var varTable_1 = require("./varTable");
var stringUtils_1 = require("../lib/stringUtils");
var constants_1 = require("../../constants");
function bar(label, value) {
    if (value === void 0) { value = 0; }
    return {
        label: label,
        value: value,
    };
}
var OverviewValueAtRiskContainer = (function (_super) {
    __extends(OverviewValueAtRiskContainer, _super);
    function OverviewValueAtRiskContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewValueAtRiskContainer.prototype.get_format = function (data) {
        var value_flat_list = [];
        for (var i = 0; i < data.length; i++) {
            var values = data[i]['values'];
            for (var j = 0; j < values.length; j++) {
                value_flat_list.push(values[j]['value']);
            }
        }
        ;
        var max = Math.max.apply(null, value_flat_list);
        var min = Math.min.apply(null, value_flat_list);
        var b = 2;
        var e = Math.floor(Math.log(max) / Math.LN10);
        return '.' + Math.min(Math.max(0, b - e), b) + 'f';
    };
    OverviewValueAtRiskContainer.prototype.getLabelStacks = function (label, type, value) {
        var GROSS = constants_1.EvaluationTypeChoices.GROSS;
        var PRESENT = constants_1.EvaluationTypeChoices.PRESENT;
        var NETT = constants_1.EvaluationTypeChoices.NETT;
        var labels = {};
        labels[GROSS] = "".concat(label, " (").concat(constants_1.EvaluationTypeChoices.display(GROSS), ")");
        labels[PRESENT] = "".concat(label, " (").concat(constants_1.EvaluationTypeChoices.display(PRESENT), ")");
        labels[NETT] = "".concat(label, " (").concat(constants_1.EvaluationTypeChoices.display(NETT), " + ").concat(gettext("cost"), ")");
        switch (type.toString()) {
            case GROSS.toString():
                if (this.props.eval_types.length == 3) {
                    return [bar(labels[GROSS], value), bar(labels[PRESENT]), bar(labels[NETT])];
                }
                else {
                    return [bar(labels[GROSS], value), bar(labels[NETT])];
                }
            case PRESENT.toString():
                if (this.props.eval_types.length == 3) {
                    return [bar(labels[GROSS]), bar(labels[PRESENT], value), bar(labels[NETT])];
                }
                else {
                    return [bar(labels[PRESENT], value), bar(labels[NETT])];
                }
            case NETT.toString():
                if (this.props.eval_types.length == 3) {
                    return [bar(labels[GROSS]), bar(labels[PRESENT]), bar(labels[NETT], value)];
                }
                else if (this.props.eval_types.length == 2) {
                    if (this.props.eval_types.indexOf(PRESENT.toString()) == -1) {
                        return [bar(labels[GROSS]), bar(labels[NETT], value)];
                    }
                    else {
                        return [bar(labels[PRESENT]), bar(labels[NETT], value)];
                    }
                }
                else {
                    return [bar(labels[NETT], value)];
                }
            default:
                throw new Error("Unknown type.");
        }
    };
    OverviewValueAtRiskContainer.prototype.formatData = function (data) {
        var _this = this;
        var filtered_values = data.values.filter(function (value) {
            return _this.props.eval_types.indexOf(value.type.toString()) !== -1;
        });
        if (this.props.include_cost && this.props.eval_types.indexOf(constants_1.EvaluationTypeChoices.NETT.toString()) > -1) {
            var label_1 = filtered_values[0].values[0].label;
            filtered_values.map(function (value) {
                value.values = _this.getLabelStacks(label_1, value.type.toString(), value.values[0].value);
                return value;
            });
            filtered_values.push({
                key: "cost",
                color: "gray",
                values: this.getLabelStacks(label_1, constants_1.EvaluationTypeChoices.NETT.toString(), data.cost_total),
            });
        }
        return filtered_values;
    };
    OverviewValueAtRiskContainer.prototype.render = function () {
        var _this = this;
        var data = this.props.data;
        var new_values = this.formatData(JSON.parse(JSON.stringify(data)));
        return (React.createElement(container_1.Container, { fullWidth: true, containerTitle: data.title },
            React.createElement(container_1.Container, { borderless: true },
                React.createElement("div", { className: "OverviewValueAtRisk__ChartSection" },
                    React.createElement(charts_1.MultiBarChart, { data: new_values, format: this.get_format(new_values), yAxisLabel: data.unit, showLegend: true, disableLegendUpdate: true, chartWidth: 380, stacked: this.props.include_cost }))),
            React.createElement(container_1.Container, { borderless: true, containerSubTitle: gettext("Top contributing risks to Value at Risk (VaR)") }, this.props.data.evaluations.filter(function (evaluations) { return _this.props.eval_types.indexOf(evaluations.evaluation_type.toString()) !== -1; }).map(function (evaluation, i) {
                return (React.createElement(OverviewValueAtRiskTable, { key: i, value: evaluation, crossProject: _this.props.data.cross_project, number_to_show: _this.props.number_to_show }));
            }))));
    };
    return OverviewValueAtRiskContainer;
}(React.Component));
exports.OverviewValueAtRiskContainer = OverviewValueAtRiskContainer;
var OverviewValueAtRiskTable = (function (_super) {
    __extends(OverviewValueAtRiskTable, _super);
    function OverviewValueAtRiskTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewValueAtRiskTable.prototype.render = function () {
        var value = this.props.value;
        var number_to_show = this.props.number_to_show;
        var evaluations = value.evaluations
            .sort(function (a, b) { return b.var - a.var; });
        if (number_to_show != "All") {
            evaluations = evaluations.slice(0, parseInt(number_to_show));
        }
        var calc_total_var = 0;
        for (var i = 0; i < evaluations.length; i++) {
            calc_total_var += evaluations[i].var;
        }
        var max_calc = value.akk_var_list.length;
        var total_var = value.akk_var_list[max_calc - 1];
        var sub_total_var = total_var;
        if (parseInt(number_to_show) < max_calc) {
            sub_total_var = value.akk_var_list[parseInt(number_to_show) - 1];
        }
        return (React.createElement(varTable_1.ValueAtRiskTable, { evaluations: evaluations, cross_project: this.props.crossProject, var_total: total_var, title: (0, stringUtils_1.capitalizeFirstLetter)(value.evaluation), sub_total_var: sub_total_var, calc_total_var: calc_total_var }));
    };
    return OverviewValueAtRiskTable;
}(React.Component));
exports.OverviewValueAtRiskTable = OverviewValueAtRiskTable;
